import { useQuery } from "@tanstack/react-query";

import { CouponsQueryKeys } from "./couponsQueryKeys";
import { getUserCoupon } from "@/api/coupons";
import { useLocale } from "next-intl";

interface UseUserCouponParams {
  couponId: string | null;
  userId: number | null;
}

export const useUserCoupon = ({ couponId, userId }: UseUserCouponParams) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [CouponsQueryKeys.UserSingle, couponId, userId],
    enabled: Boolean(couponId) && Boolean(userId),
    queryFn: ({ signal }) => {
      return getUserCoupon({
        signal,
        params: { couponId: couponId!, lang: locale },
      });
    },
    // While any leg's match is live the detail keeps polling, so the
    // per-leg "if it ended now" trend (currentBetStatus) and the scores
    // follow the game — the same cadence the player's own coupon query uses.
    refetchInterval: (query) => {
      const data = query.state.data;
      const hasLive = data?.selections?.some(
        (s) => s.matchStatus === "live"
      );
      return hasLive ? 30_000 : false;
    },
  });
};
